import { Box, Typography } from '@mui/material';
import { WarningIcon } from './WarningIcon';
import { useIntl } from 'react-intl';

export const WarningMessage = () => {
      const { formatMessage } = useIntl();
  
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        borderRadius: '8px',
      }}
    >
      <WarningIcon />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '',
        }}
      >
        <Typography
          sx={{
            fontWeight: 'bold',
            display: 'flex',
            fontSize: '18px',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            paddingTop: '10px',
          }}
        >
          {formatMessage({ id: "compilance.ko.title" })}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '20px',
          color: 'red',
        }}
      >
        <Typography
          sx={{
            fontWeight: 'bold',
            color: 'red',
            margin: '0 5px',
            fontSize: '20px',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
          }}
        >
          {formatMessage({ id: "compilance.ko.text" })}
        </Typography>
      </Box>
    </Box>
  );
}

